// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"938e6394","893":"c090f033"}[chunkId] + ".chunk.js";
};